// extracted by mini-css-extract-plugin
export default {"card-section":"NftCardSection_card-section__OMnp0"};